import Style from "./initials.module.scss";

const Initials = ({ initial }) => {
  return <span className={Style.Initials}>{initial}</span>;
};

export default Initials;
